import { init as init$1 } from '@cian/config/browser';
import { init as init$3 } from '@cian/http-api/browser';
import { init as init$2 } from '@cian/logger/browser';
import { setupWebpackPublicPath } from './setup.mjs';
import { initWebVitals } from './vitals.mjs';

function init() {
    init$1();
    init$2();
    init$3();
    initWebVitals();
    setupWebpackPublicPath();
}

export { init };
//# sourceMappingURL=interface.mjs.map
